import RadioGroup from "@shared/radio-group";

import { DocumentationInfo } from "./order-api-tags";
import { type OrdersApiStepMetadata } from "./step-metadata";

export const OrderTagsConfirmation = ({
  stepMetadata,
  updateStepMetadata,
  isMarkedComplete,
}: {
  stepMetadata: OrdersApiStepMetadata;
  updateStepMetadata: (metadata: OrdersApiStepMetadata) => void;
  isMarkedComplete?: boolean;
}) => (
  <>
    <h1 className="mb-2">8b. Tell us if your brand will use Order Tags</h1>
    <div className="text-md mb-5">
      Order tags play a wide variety of roles when it comes to an how ads that
      may have driven the order are attributed.
    </div>
    <DocumentationInfo
      docTitle="Learn about the 'Order Tagging'"
      link="https://docs.northbeam.io/docs/orders-api#roles-of-order_tags-of-an-order"
      iconClassName="fa-sharp fa-solid fa-book"
    />
    <div className="w-full space-y-6">
      <RadioGroup
        className="mt-6 text-lg space-y-6"
        options={[
          {
            label: "Yes, we will use order tags (recommended)",
            value: "yes",
            disabled: isMarkedComplete,
            disabledTooltip:
              "Uncheck the 'Complete' checkbox at the bottom of the screen to update",
          },
          {
            label: "No, we wont use order tags",
            value: "no",
            disabled: isMarkedComplete,
            disabledTooltip:
              "Uncheck the 'Complete' checkbox at the bottom of the screen to update",
          },
        ]}
        value={stepMetadata.doNotUseOrderTags ? "no" : "yes"}
        onChange={(value) => {
          updateStepMetadata({
            ...stepMetadata,
            doNotUseOrderTags: value === "no",
          });
        }}
      />
      {stepMetadata.doNotUseOrderTags && (
        <div className="w-full p-4 flex gap-4 bg-sun-2 border rounded items-center text-lg">
          <i className="fa-sharp fa-regular fa-warning font-black text-[#FFB300]" />
          <span>
            <b>Almost all Northbeam customers use order tags.</b> Make sure you
            truly don't need this feature.
          </span>
        </div>
      )}
    </div>
  </>
);
